module.exports = "/_next/static/images/li-3719ea6d2824fa73d84a99bc930d4191.svg";